import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./Theme";

import StickyFooter from "./components/Footer";
import FloatingQuoteButton from "./components/FloatingButton";
import ScrollToTop from "./components/ScrollToTop";
import OptimizedImage from "./components/OptimizedImage";
import Nav from "./components/Nav";   // ✅ Always visible
import Header from "./components/Header"; // ✅ Only homepage

// Lazy-loaded pages
const Home = lazy(() => import("./pages/home"));
const WhoWeAre = lazy(() => import("./pages/whoWeAre"));
const Contact = lazy(() => import("./pages/contactUs"));
const GetAQuote = lazy(() => import("./pages/getAQuote"));
const Services = lazy(() => import("./pages/services"));
const TermsAndConditions = lazy(() => import("./pages/terms"));
const PrivacyPolicy = lazy(() => import("./pages/privacy"));

function Layout({ children }) {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Nav /> {/* ✅ Always show Nav */}

      {isHome && <Header />} {/* ✅ Only show Header on home */}

      <Box component="main" flexGrow={1}>
        {children}
      </Box>

      <StickyFooter />
    </Box>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />

        {/* Background image container */}
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            width: "100%",
            height: "100%",
            zIndex: -1,
            backgroundColor: "#000",
          }}
        >
          <OptimizedImage
            src="https://res.cloudinary.com/dd2f8xsjr/image/upload/f_auto,q_auto/bgimage_m91gpx"
            alt="Background"
            widths={[480, 768, 1200, 1920]}
            isLCP={true}
            sizes="100vw"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              inset: 0,
            }}
          />
        </Box>

        <Suspense fallback={<Box sx={{ minHeight: "400px" }}>Loading...</Box>}>
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/who-we-are" element={<Layout><WhoWeAre /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/get-a-quote" element={<Layout><GetAQuote /></Layout>} />
            <Route path="/services" element={<Layout><Services /></Layout>} />
            <Route path="/terms" element={<Layout><TermsAndConditions /></Layout>} />
            <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
          </Routes>
        </Suspense>

        <FloatingQuoteButton />
      </Router>
    </ThemeProvider>
  );
}
